import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { CITIES } from "../data/cities";

export const CoverageChecker = () => {
    const [query, setQuery] = useState("");
    const navigate = useNavigate();

    const check = (e) => {
        e.preventDefault();
        const q = query.trim().toLowerCase();
        if (!q) return;
        const hit = CITIES.find(
            (c) => c.name.toLowerCase().includes(q) || c.slug.includes(q.replace(/\s+/g, "-")) || c.region.toLowerCase().includes(q)
        );
        navigate(hit ? `/locations/${hit.slug}` : "/locations");
    };

    return (
        <div className="bg-[#0F1117] border border-white/10" data-testid="coverage-checker">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid md:grid-cols-2 gap-8 items-center">
                <div>
                    <p className="font-mono-xp text-[11px] uppercase tracking-[0.3em] text-[#E53E3E] mb-3">Coverage Checker</p>
                    <h2 className="font-display uppercase font-bold text-3xl sm:text-4xl tracking-wide text-white leading-none">
                        Do we cover your area?
                    </h2>
                    <p className="text-gray-400 text-sm leading-relaxed mt-4 max-w-md">
                        Enter your Scottish town or city and jump straight to your local security pages — 46+ locations, 17 specialist services, one standard.
                    </p>
                </div>
                <form onSubmit={check} className="flex gap-0" data-testid="coverage-form">
                    <div className="flex items-center flex-1 bg-[#07080B] border border-white/15 focus-within:border-[#E53E3E]/60 transition-colors">
                        <MapPin size={16} className="ml-4 text-gray-500 shrink-0" />
                        <input
                            type="text"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="e.g. Glasgow, Edinburgh, Aberdeen…"
                            data-testid="coverage-input"
                            className="w-full bg-transparent px-3 py-4 text-sm text-white placeholder:text-gray-600 focus:outline-none font-mono-xp"
                        />
                    </div>
                    <button
                        type="submit"
                        data-testid="coverage-check-button"
                        className="flex items-center gap-2 bg-[#E53E3E] hover:bg-[#c93636] transition-colors duration-300 text-white font-mono-xp text-xs uppercase tracking-widest px-6"
                    >
                        Check <ArrowRight size={14} />
                    </button>
                </form>
            </div>
        </div>
    );
};
